import React from 'react';
import PropTypes from 'prop-types';

import getHelmetForAuthor from 'SharedHelpers/getHelmetForAuthor';

import {
  getHelmetForHome,
  getHelmetForErrorPage,
  getHelmetForGallery,
  getHelmetForIndexTemplate,
  getHelmetForLoading,
  getHelmetForNotFound,
  getHelmetForPage,
  getHelmetForSearch,
  getHelmetForSpec,
  getHelmetForArticle,
  getHelmetForReview,
} from './getHelmet';

const getHelmetForTemplate = (templateName) => {
  const helmets = {
    author: getHelmetForAuthor,
    home: getHelmetForHome,
    error: getHelmetForErrorPage,
    gallery: getHelmetForGallery,
    index: getHelmetForIndexTemplate,
    loading: getHelmetForLoading,
    notFound: getHelmetForNotFound,
    page: getHelmetForPage,
    search: getHelmetForSearch,
    spec: getHelmetForSpec,
    article: getHelmetForArticle,
    review: getHelmetForReview,
  };

  return helmets[templateName];
};

export const withHelmet = templateName => (BaseComponent) => {
  const BaseComponentWithHelmet = (props) => {
    const Helmet = getHelmetForTemplate(templateName);
    return (
      <>
        <Helmet {...props} />
        <BaseComponent {...props} />
      </>
    );
  };

  withHelmet.propTypes = {
    config: PropTypes.shape({}).isRequired,
    layoutData: PropTypes.shape({
      page: PropTypes.shape({
        author: PropTypes.shape({
          name: PropTypes.string,
          bio: PropTypes.string,
          firstName: PropTypes.string,
          lastName: PropTypes.string,
          photo: PropTypes.string,
        }),
      }).isRequired,
      pagination: PropTypes.shape({
        isLoading: PropTypes.bool,
        loadMore: PropTypes.func,
        page: PropTypes.number,
        pages: PropTypes.object,
        setPageRef: PropTypes.func,
        hasMore: PropTypes.bool,
      }),
    }).isRequired,
  };
  withHelmet.defaultProps = {
    pagination: {
      isLoading: false,
      loadMore: () => null,
      page: 0,
      pages: 0,
      setPageRef: () => null,
      hasMore: false,
    },
  };
  withHelmet.displayName = 'withHelmet()';

  return BaseComponentWithHelmet;
};
